import HomePage from "./pages/home/HomePage";
import AboutUs from "./pages/about/AboutUs";

// Redux
import { useSelector } from "react-redux";

// Router import
import {
  createBrowserRouter,
  Route,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";

// Layouts
import RootLayout from "./layouts/RootLayout";
import FieldsLayout from "./layouts/FieldsLayout";

//Fields data
import { fields } from "./store/store";
import FieldDescription from "./pages/fields/FieldDescription";

// Components
import ContactForm from "./components/ContactForm";
import Publications from "./pages/publications/Publications";

// Helmet
import { HelmetProvider } from "react-helmet-async";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<HomePage />} />
      <Route path="fields" element={<FieldsLayout />}>
        {fields.map((field) => (
          <Route
            path={field.fieldRoute}
            element={<FieldDescription field={field} />}
            key={field.fieldId}
          ></Route>
        ))}
      </Route>
      <Route path="about-us" element={<AboutUs />} />
      <Route path="publications" element={<Publications />} />
    </Route>
  )
);

function App() {
  const contactOpen = useSelector((state) => state.contactIsOpen);

  return (
    <HelmetProvider>
      {contactOpen && <ContactForm />}
      <RouterProvider router={router} />
    </HelmetProvider>
  );
}

export default App;
